import { AbstractFlow3bixaw6q3bbim as AbstractFlow } from './Flow.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ChannelFlowvdfy82kdxy2m as ChannelFlow } from './internal/ChannelFlow.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../channels/BufferOverflow.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flow(block) {
  return new (SafeFlow())(block);
}
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (asFlow$$inlined$unsafeFlow$1())(_this__u8e3s4);
}
var SafeFlowClass;
function SafeFlow() {
  if (SafeFlowClass === VOID) {
    class $_0 extends AbstractFlow() {
      constructor(block) {
        super();
        this.block_1 = block;
      }
      *collectSafely_blptet_k$(collector, $completion) {
        yield* $(this.block_1(collector, $completion), $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($_0, 'SafeFlow', VOID, VOID, VOID, [1]);
    SafeFlowClass = $_0;
  }
  return SafeFlowClass;
}
function channelFlow(block) {
  return new (ChannelFlowBuilder())(block);
}
function flowOf(value) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (flowOf$$inlined$unsafeFlow$1())(value);
}
function callbackFlow(block) {
  return new (CallbackFlowBuilder())(block);
}
var ChannelFlowBuilderClass;
function ChannelFlowBuilder() {
  if (ChannelFlowBuilderClass === VOID) {
    class $_0 extends ChannelFlow() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(context, capacity, onBufferOverflow);
        this.block_1 = block;
      }
      create_iagb5n_k$(context, capacity, onBufferOverflow) {
        return new (ChannelFlowBuilder())(this.block_1, context, capacity, onBufferOverflow);
      }
      *collectTo_qjwlth_k$(scope, $completion) {
        return yield* $(this.block_1(scope, $completion), $completion);
      }
      toString() {
        return 'block[' + toString(this.block_1) + '] -> ' + super.toString();
      }
    }
    initMetadataForClass($_0, 'ChannelFlowBuilder', VOID, VOID, VOID, [1]);
    ChannelFlowBuilderClass = $_0;
  }
  return ChannelFlowBuilderClass;
}
var CallbackFlowBuilderClass;
function CallbackFlowBuilder() {
  if (CallbackFlowBuilderClass === VOID) {
    class $ extends ChannelFlowBuilder() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(block, context, capacity, onBufferOverflow);
        this.block_2 = block;
      }
      *collectTo_qjwlth_k$(scope, $completion) {
        yield* protoOf(ChannelFlowBuilder()).collectTo_qjwlth_k$.call(this, scope, $completion);
        if (!scope.get_isClosedForSend_ajczci_k$()) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("'awaitClose { yourCallbackOrListener.cancel() }' should be used in the end of callbackFlow block.\nOtherwise, a callback/listener may leak in case of external cancellation.\nSee callbackFlow API documentation for the details.");
        }
        return Unit_instance;
      }
      create_iagb5n_k$(context, capacity, onBufferOverflow) {
        return new (CallbackFlowBuilder())(this.block_2, context, capacity, onBufferOverflow);
      }
    }
    initMetadataForClass($, 'CallbackFlowBuilder', VOID, VOID, VOID, [1]);
    CallbackFlowBuilderClass = $;
  }
  return CallbackFlowBuilderClass;
}
var asFlow$$inlined$unsafeFlow$1Class;
function asFlow$$inlined$unsafeFlow$1() {
  if (asFlow$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_asFlow) {
        this.$this_asFlow_1 = $this_asFlow;
      }
      *collect_ooju95_k$(collector, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.$this_asFlow_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          yield* collector.emit_t92u1f_k$(element, $completion);
        }
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    asFlow$$inlined$unsafeFlow$1Class = $;
  }
  return asFlow$$inlined$unsafeFlow$1Class;
}
var flowOf$$inlined$unsafeFlow$1Class;
function flowOf$$inlined$unsafeFlow$1() {
  if (flowOf$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($value) {
        this.$value_1 = $value;
      }
      *collect_ooju95_k$(collector, $completion) {
        yield* collector.emit_t92u1f_k$(this.$value_1, $completion);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    flowOf$$inlined$unsafeFlow$1Class = $;
  }
  return flowOf$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  asFlow as asFlow3ngsnn5xpz8pw,
  callbackFlow as callbackFlow1g384rkuy0hni,
  channelFlow as channelFlow1or0c85tk04v1,
  flowOf as flowOf16f7h10nre075,
  flow as flow3tazazxj2t7g4,
};
//endregion

//# sourceMappingURL=Builders.mjs.map
